import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { CommonClientRequestsState } from './state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forFeature([CommonClientRequestsState]),
  ]
})
export class CommonClientRequestsModule {}
